import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Standard shadcn/ui class-merge helper. Combines conditional clsx input
 * with tailwind-merge de-duplication so later classes win over earlier
 * ones for the same utility (e.g. `p-2` + `p-4` → `p-4`).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
